/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  FacilityExchangePriceListModel,
  FacilityToFacilityPriceListModel,
  HomeDeliveryAndTradeInPriceListModel,
  InternalDeliveryPriceListModel,
  PriceListActivateVersionParams,
  PriceListGetActiveHomeDeliveryVersionParams,
  PriceListGetActivePurchaseVersionParams,
  PriceListGetAllVersionsParams,
  PriceListGetFacilityExchangeVersionParams,
  PriceListGetFacilityToFacilityVersionParams,
  PriceListGetHomeDeliveryVersionParams,
  PriceListGetInternalDeliveryPriceVersionParams,
  PriceListGetPriceListInfoParams,
  PriceListGetPurchaseVersionParams,
  PriceListGetSubKeysParams,
  PriceListGetTruckDeliveryVersionParams,
  PriceListInfoModel,
  PriceListSaveHomeDeliveryVersionParams,
  PriceListSavePurchaseVersionParams,
  PriceListSummaryModel,
  PurchasePriceListModel,
  SaveFacilityExchangePriceListRequest,
  SaveFacilityToFacilityPriceListRequest,
  SaveHomeDeliveryAndTradeInPriceListRequest,
  SaveInternalDeliveryPriceListRequest,
  SavePurchasePriceListRequest,
  SaveTruckDeliveryPriceListRequest,
  TruckDeliveryPriceListModel,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const usePriceListGetPriceListInfoHook = () => {
  const priceListGetPriceListInfo = useCustomInstance<PriceListInfoModel>();

  return useCallback(
    (params?: PriceListGetPriceListInfoParams, signal?: AbortSignal) => {
      return priceListGetPriceListInfo({
        url: `/api/PriceList/GetPriceListInfo`,
        method: 'GET',
        params,
        signal,
      });
    },
    [priceListGetPriceListInfo]
  );
};

export const getPriceListGetPriceListInfoQueryKey = (
  params?: PriceListGetPriceListInfoParams
) => {
  return [
    `/api/PriceList/GetPriceListInfo`,
    ...(params ? [params] : []),
  ] as const;
};

export const usePriceListGetPriceListInfoQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof usePriceListGetPriceListInfoHook>>
  >,
  TError = unknown,
>(
  params?: PriceListGetPriceListInfoParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof usePriceListGetPriceListInfoHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPriceListGetPriceListInfoQueryKey(params);

  const priceListGetPriceListInfo = usePriceListGetPriceListInfoHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof usePriceListGetPriceListInfoHook>>>
  > = ({ signal }) => priceListGetPriceListInfo(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof usePriceListGetPriceListInfoHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PriceListGetPriceListInfoQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePriceListGetPriceListInfoHook>>>
>;
export type PriceListGetPriceListInfoQueryError = unknown;

export const usePriceListGetPriceListInfo = <
  TData = Awaited<
    ReturnType<ReturnType<typeof usePriceListGetPriceListInfoHook>>
  >,
  TError = unknown,
>(
  params?: PriceListGetPriceListInfoParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof usePriceListGetPriceListInfoHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = usePriceListGetPriceListInfoQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const usePriceListGetSubKeysHook = () => {
  const priceListGetSubKeys = useCustomInstance<string[]>();

  return useCallback(
    (params?: PriceListGetSubKeysParams, signal?: AbortSignal) => {
      return priceListGetSubKeys({
        url: `/api/PriceList/GetSubKeys`,
        method: 'GET',
        params,
        signal,
      });
    },
    [priceListGetSubKeys]
  );
};

export const getPriceListGetSubKeysQueryKey = (
  params?: PriceListGetSubKeysParams
) => {
  return [`/api/PriceList/GetSubKeys`, ...(params ? [params] : [])] as const;
};

export const usePriceListGetSubKeysQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof usePriceListGetSubKeysHook>>>,
  TError = unknown,
>(
  params?: PriceListGetSubKeysParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof usePriceListGetSubKeysHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPriceListGetSubKeysQueryKey(params);

  const priceListGetSubKeys = usePriceListGetSubKeysHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof usePriceListGetSubKeysHook>>>
  > = ({ signal }) => priceListGetSubKeys(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof usePriceListGetSubKeysHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PriceListGetSubKeysQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePriceListGetSubKeysHook>>>
>;
export type PriceListGetSubKeysQueryError = unknown;

export const usePriceListGetSubKeys = <
  TData = Awaited<ReturnType<ReturnType<typeof usePriceListGetSubKeysHook>>>,
  TError = unknown,
>(
  params?: PriceListGetSubKeysParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof usePriceListGetSubKeysHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = usePriceListGetSubKeysQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const usePriceListGetAllVersionsHook = () => {
  const priceListGetAllVersions = useCustomInstance<PriceListSummaryModel[]>();

  return useCallback(
    (params?: PriceListGetAllVersionsParams, signal?: AbortSignal) => {
      return priceListGetAllVersions({
        url: `/api/PriceList/GetAllVersions`,
        method: 'GET',
        params,
        signal,
      });
    },
    [priceListGetAllVersions]
  );
};

export const getPriceListGetAllVersionsQueryKey = (
  params?: PriceListGetAllVersionsParams
) => {
  return [
    `/api/PriceList/GetAllVersions`,
    ...(params ? [params] : []),
  ] as const;
};

export const usePriceListGetAllVersionsQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof usePriceListGetAllVersionsHook>>
  >,
  TError = unknown,
>(
  params?: PriceListGetAllVersionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof usePriceListGetAllVersionsHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPriceListGetAllVersionsQueryKey(params);

  const priceListGetAllVersions = usePriceListGetAllVersionsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof usePriceListGetAllVersionsHook>>>
  > = ({ signal }) => priceListGetAllVersions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof usePriceListGetAllVersionsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PriceListGetAllVersionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePriceListGetAllVersionsHook>>>
>;
export type PriceListGetAllVersionsQueryError = unknown;

export const usePriceListGetAllVersions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof usePriceListGetAllVersionsHook>>
  >,
  TError = unknown,
>(
  params?: PriceListGetAllVersionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof usePriceListGetAllVersionsHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = usePriceListGetAllVersionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const usePriceListActivateVersionHook = () => {
  const priceListActivateVersion = useCustomInstance<void>();

  return useCallback(
    (params?: PriceListActivateVersionParams) => {
      return priceListActivateVersion({
        url: `/api/PriceList/ActivateVersion`,
        method: 'POST',
        params,
      });
    },
    [priceListActivateVersion]
  );
};

export const usePriceListActivateVersionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePriceListActivateVersionHook>>>,
    TError,
    { params?: PriceListActivateVersionParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof usePriceListActivateVersionHook>>>,
  TError,
  { params?: PriceListActivateVersionParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const priceListActivateVersion = usePriceListActivateVersionHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof usePriceListActivateVersionHook>>>,
    { params?: PriceListActivateVersionParams }
  > = (props) => {
    const { params } = props ?? {};

    return priceListActivateVersion(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type PriceListActivateVersionMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePriceListActivateVersionHook>>>
>;

export type PriceListActivateVersionMutationError = unknown;

export const usePriceListActivateVersion = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePriceListActivateVersionHook>>>,
    TError,
    { params?: PriceListActivateVersionParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof usePriceListActivateVersionHook>>>,
  TError,
  { params?: PriceListActivateVersionParams },
  TContext
> => {
  const mutationOptions = usePriceListActivateVersionMutationOptions(options);

  return useMutation(mutationOptions);
};
export const usePriceListGetTruckDeliveryVersionHook = () => {
  const priceListGetTruckDeliveryVersion =
    useCustomInstance<TruckDeliveryPriceListModel>();

  return useCallback(
    (params?: PriceListGetTruckDeliveryVersionParams, signal?: AbortSignal) => {
      return priceListGetTruckDeliveryVersion({
        url: `/api/PriceList/GetTruckDeliveryVersion`,
        method: 'GET',
        params,
        signal,
      });
    },
    [priceListGetTruckDeliveryVersion]
  );
};

export const getPriceListGetTruckDeliveryVersionQueryKey = (
  params?: PriceListGetTruckDeliveryVersionParams
) => {
  return [
    `/api/PriceList/GetTruckDeliveryVersion`,
    ...(params ? [params] : []),
  ] as const;
};

export const usePriceListGetTruckDeliveryVersionQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof usePriceListGetTruckDeliveryVersionHook>>
  >,
  TError = unknown,
>(
  params?: PriceListGetTruckDeliveryVersionParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof usePriceListGetTruckDeliveryVersionHook>>
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPriceListGetTruckDeliveryVersionQueryKey(params);

  const priceListGetTruckDeliveryVersion =
    usePriceListGetTruckDeliveryVersionHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof usePriceListGetTruckDeliveryVersionHook>>
    >
  > = ({ signal }) => priceListGetTruckDeliveryVersion(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof usePriceListGetTruckDeliveryVersionHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PriceListGetTruckDeliveryVersionQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof usePriceListGetTruckDeliveryVersionHook>>
  >
>;
export type PriceListGetTruckDeliveryVersionQueryError = unknown;

export const usePriceListGetTruckDeliveryVersion = <
  TData = Awaited<
    ReturnType<ReturnType<typeof usePriceListGetTruckDeliveryVersionHook>>
  >,
  TError = unknown,
>(
  params?: PriceListGetTruckDeliveryVersionParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof usePriceListGetTruckDeliveryVersionHook>>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = usePriceListGetTruckDeliveryVersionQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const usePriceListGetActiveTruckDeliveryVersionHook = () => {
  const priceListGetActiveTruckDeliveryVersion =
    useCustomInstance<TruckDeliveryPriceListModel>();

  return useCallback(
    (signal?: AbortSignal) => {
      return priceListGetActiveTruckDeliveryVersion({
        url: `/api/PriceList/GetActiveTruckDeliveryVersion`,
        method: 'GET',
        signal,
      });
    },
    [priceListGetActiveTruckDeliveryVersion]
  );
};

export const getPriceListGetActiveTruckDeliveryVersionQueryKey = () => {
  return [`/api/PriceList/GetActiveTruckDeliveryVersion`] as const;
};

export const usePriceListGetActiveTruckDeliveryVersionQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof usePriceListGetActiveTruckDeliveryVersionHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListGetActiveTruckDeliveryVersionHook>
      >
    >,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPriceListGetActiveTruckDeliveryVersionQueryKey();

  const priceListGetActiveTruckDeliveryVersion =
    usePriceListGetActiveTruckDeliveryVersionHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListGetActiveTruckDeliveryVersionHook>
      >
    >
  > = ({ signal }) => priceListGetActiveTruckDeliveryVersion(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListGetActiveTruckDeliveryVersionHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PriceListGetActiveTruckDeliveryVersionQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof usePriceListGetActiveTruckDeliveryVersionHook>>
  >
>;
export type PriceListGetActiveTruckDeliveryVersionQueryError = unknown;

export const usePriceListGetActiveTruckDeliveryVersion = <
  TData = Awaited<
    ReturnType<ReturnType<typeof usePriceListGetActiveTruckDeliveryVersionHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListGetActiveTruckDeliveryVersionHook>
      >
    >,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    usePriceListGetActiveTruckDeliveryVersionQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const usePriceListSaveTruckDeliveryVersionHook = () => {
  const priceListSaveTruckDeliveryVersion = useCustomInstance<number>();

  return useCallback(
    (saveTruckDeliveryPriceListRequest: SaveTruckDeliveryPriceListRequest) => {
      return priceListSaveTruckDeliveryVersion({
        url: `/api/PriceList/SaveTruckDeliveryVersion`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: saveTruckDeliveryPriceListRequest,
      });
    },
    [priceListSaveTruckDeliveryVersion]
  );
};

export const usePriceListSaveTruckDeliveryVersionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof usePriceListSaveTruckDeliveryVersionHook>>
    >,
    TError,
    { data: SaveTruckDeliveryPriceListRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof usePriceListSaveTruckDeliveryVersionHook>>
  >,
  TError,
  { data: SaveTruckDeliveryPriceListRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const priceListSaveTruckDeliveryVersion =
    usePriceListSaveTruckDeliveryVersionHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof usePriceListSaveTruckDeliveryVersionHook>>
    >,
    { data: SaveTruckDeliveryPriceListRequest }
  > = (props) => {
    const { data } = props ?? {};

    return priceListSaveTruckDeliveryVersion(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PriceListSaveTruckDeliveryVersionMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof usePriceListSaveTruckDeliveryVersionHook>>
  >
>;
export type PriceListSaveTruckDeliveryVersionMutationBody =
  SaveTruckDeliveryPriceListRequest;
export type PriceListSaveTruckDeliveryVersionMutationError = unknown;

export const usePriceListSaveTruckDeliveryVersion = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof usePriceListSaveTruckDeliveryVersionHook>>
    >,
    TError,
    { data: SaveTruckDeliveryPriceListRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof usePriceListSaveTruckDeliveryVersionHook>>
  >,
  TError,
  { data: SaveTruckDeliveryPriceListRequest },
  TContext
> => {
  const mutationOptions =
    usePriceListSaveTruckDeliveryVersionMutationOptions(options);

  return useMutation(mutationOptions);
};
export const usePriceListGetPurchaseVersionHook = () => {
  const priceListGetPurchaseVersion =
    useCustomInstance<PurchasePriceListModel>();

  return useCallback(
    (params?: PriceListGetPurchaseVersionParams, signal?: AbortSignal) => {
      return priceListGetPurchaseVersion({
        url: `/api/PriceList/GetPurchaseVersion`,
        method: 'GET',
        params,
        signal,
      });
    },
    [priceListGetPurchaseVersion]
  );
};

export const getPriceListGetPurchaseVersionQueryKey = (
  params?: PriceListGetPurchaseVersionParams
) => {
  return [
    `/api/PriceList/GetPurchaseVersion`,
    ...(params ? [params] : []),
  ] as const;
};

export const usePriceListGetPurchaseVersionQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof usePriceListGetPurchaseVersionHook>>
  >,
  TError = unknown,
>(
  params?: PriceListGetPurchaseVersionParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof usePriceListGetPurchaseVersionHook>>
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPriceListGetPurchaseVersionQueryKey(params);

  const priceListGetPurchaseVersion = usePriceListGetPurchaseVersionHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof usePriceListGetPurchaseVersionHook>>>
  > = ({ signal }) => priceListGetPurchaseVersion(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof usePriceListGetPurchaseVersionHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PriceListGetPurchaseVersionQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePriceListGetPurchaseVersionHook>>>
>;
export type PriceListGetPurchaseVersionQueryError = unknown;

export const usePriceListGetPurchaseVersion = <
  TData = Awaited<
    ReturnType<ReturnType<typeof usePriceListGetPurchaseVersionHook>>
  >,
  TError = unknown,
>(
  params?: PriceListGetPurchaseVersionParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof usePriceListGetPurchaseVersionHook>>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = usePriceListGetPurchaseVersionQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const usePriceListGetActivePurchaseVersionHook = () => {
  const priceListGetActivePurchaseVersion =
    useCustomInstance<PurchasePriceListModel>();

  return useCallback(
    (
      params?: PriceListGetActivePurchaseVersionParams,
      signal?: AbortSignal
    ) => {
      return priceListGetActivePurchaseVersion({
        url: `/api/PriceList/GetActivePurchaseVersion`,
        method: 'GET',
        params,
        signal,
      });
    },
    [priceListGetActivePurchaseVersion]
  );
};

export const getPriceListGetActivePurchaseVersionQueryKey = (
  params?: PriceListGetActivePurchaseVersionParams
) => {
  return [
    `/api/PriceList/GetActivePurchaseVersion`,
    ...(params ? [params] : []),
  ] as const;
};

export const usePriceListGetActivePurchaseVersionQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof usePriceListGetActivePurchaseVersionHook>>
  >,
  TError = unknown,
>(
  params?: PriceListGetActivePurchaseVersionParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof usePriceListGetActivePurchaseVersionHook>>
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPriceListGetActivePurchaseVersionQueryKey(params);

  const priceListGetActivePurchaseVersion =
    usePriceListGetActivePurchaseVersionHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof usePriceListGetActivePurchaseVersionHook>>
    >
  > = ({ signal }) => priceListGetActivePurchaseVersion(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof usePriceListGetActivePurchaseVersionHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PriceListGetActivePurchaseVersionQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof usePriceListGetActivePurchaseVersionHook>>
  >
>;
export type PriceListGetActivePurchaseVersionQueryError = unknown;

export const usePriceListGetActivePurchaseVersion = <
  TData = Awaited<
    ReturnType<ReturnType<typeof usePriceListGetActivePurchaseVersionHook>>
  >,
  TError = unknown,
>(
  params?: PriceListGetActivePurchaseVersionParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof usePriceListGetActivePurchaseVersionHook>>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = usePriceListGetActivePurchaseVersionQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const usePriceListSavePurchaseVersionHook = () => {
  const priceListSavePurchaseVersion = useCustomInstance<number>();

  return useCallback(
    (
      savePurchasePriceListRequest: SavePurchasePriceListRequest,
      params?: PriceListSavePurchaseVersionParams
    ) => {
      return priceListSavePurchaseVersion({
        url: `/api/PriceList/SavePurchaseVersion`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: savePurchasePriceListRequest,
        params,
      });
    },
    [priceListSavePurchaseVersion]
  );
};

export const usePriceListSavePurchaseVersionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePriceListSavePurchaseVersionHook>>>,
    TError,
    {
      data: SavePurchasePriceListRequest;
      params?: PriceListSavePurchaseVersionParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof usePriceListSavePurchaseVersionHook>>>,
  TError,
  {
    data: SavePurchasePriceListRequest;
    params?: PriceListSavePurchaseVersionParams;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const priceListSavePurchaseVersion = usePriceListSavePurchaseVersionHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof usePriceListSavePurchaseVersionHook>>>,
    {
      data: SavePurchasePriceListRequest;
      params?: PriceListSavePurchaseVersionParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return priceListSavePurchaseVersion(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type PriceListSavePurchaseVersionMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePriceListSavePurchaseVersionHook>>>
>;
export type PriceListSavePurchaseVersionMutationBody =
  SavePurchasePriceListRequest;
export type PriceListSavePurchaseVersionMutationError = unknown;

export const usePriceListSavePurchaseVersion = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePriceListSavePurchaseVersionHook>>>,
    TError,
    {
      data: SavePurchasePriceListRequest;
      params?: PriceListSavePurchaseVersionParams;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof usePriceListSavePurchaseVersionHook>>>,
  TError,
  {
    data: SavePurchasePriceListRequest;
    params?: PriceListSavePurchaseVersionParams;
  },
  TContext
> => {
  const mutationOptions =
    usePriceListSavePurchaseVersionMutationOptions(options);

  return useMutation(mutationOptions);
};
export const usePriceListGetHomeDeliveryVersionHook = () => {
  const priceListGetHomeDeliveryVersion =
    useCustomInstance<HomeDeliveryAndTradeInPriceListModel>();

  return useCallback(
    (params?: PriceListGetHomeDeliveryVersionParams, signal?: AbortSignal) => {
      return priceListGetHomeDeliveryVersion({
        url: `/api/PriceList/GetHomeDeliveryVersion`,
        method: 'GET',
        params,
        signal,
      });
    },
    [priceListGetHomeDeliveryVersion]
  );
};

export const getPriceListGetHomeDeliveryVersionQueryKey = (
  params?: PriceListGetHomeDeliveryVersionParams
) => {
  return [
    `/api/PriceList/GetHomeDeliveryVersion`,
    ...(params ? [params] : []),
  ] as const;
};

export const usePriceListGetHomeDeliveryVersionQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof usePriceListGetHomeDeliveryVersionHook>>
  >,
  TError = unknown,
>(
  params?: PriceListGetHomeDeliveryVersionParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof usePriceListGetHomeDeliveryVersionHook>>
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPriceListGetHomeDeliveryVersionQueryKey(params);

  const priceListGetHomeDeliveryVersion =
    usePriceListGetHomeDeliveryVersionHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof usePriceListGetHomeDeliveryVersionHook>>
    >
  > = ({ signal }) => priceListGetHomeDeliveryVersion(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof usePriceListGetHomeDeliveryVersionHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PriceListGetHomeDeliveryVersionQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePriceListGetHomeDeliveryVersionHook>>>
>;
export type PriceListGetHomeDeliveryVersionQueryError = unknown;

export const usePriceListGetHomeDeliveryVersion = <
  TData = Awaited<
    ReturnType<ReturnType<typeof usePriceListGetHomeDeliveryVersionHook>>
  >,
  TError = unknown,
>(
  params?: PriceListGetHomeDeliveryVersionParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof usePriceListGetHomeDeliveryVersionHook>>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = usePriceListGetHomeDeliveryVersionQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const usePriceListGetActiveHomeDeliveryVersionHook = () => {
  const priceListGetActiveHomeDeliveryVersion =
    useCustomInstance<HomeDeliveryAndTradeInPriceListModel>();

  return useCallback(
    (
      params?: PriceListGetActiveHomeDeliveryVersionParams,
      signal?: AbortSignal
    ) => {
      return priceListGetActiveHomeDeliveryVersion({
        url: `/api/PriceList/GetActiveHomeDeliveryVersion`,
        method: 'GET',
        params,
        signal,
      });
    },
    [priceListGetActiveHomeDeliveryVersion]
  );
};

export const getPriceListGetActiveHomeDeliveryVersionQueryKey = (
  params?: PriceListGetActiveHomeDeliveryVersionParams
) => {
  return [
    `/api/PriceList/GetActiveHomeDeliveryVersion`,
    ...(params ? [params] : []),
  ] as const;
};

export const usePriceListGetActiveHomeDeliveryVersionQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof usePriceListGetActiveHomeDeliveryVersionHook>>
  >,
  TError = unknown,
>(
  params?: PriceListGetActiveHomeDeliveryVersionParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof usePriceListGetActiveHomeDeliveryVersionHook>
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPriceListGetActiveHomeDeliveryVersionQueryKey(params);

  const priceListGetActiveHomeDeliveryVersion =
    usePriceListGetActiveHomeDeliveryVersionHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListGetActiveHomeDeliveryVersionHook>
      >
    >
  > = ({ signal }) => priceListGetActiveHomeDeliveryVersion(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListGetActiveHomeDeliveryVersionHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PriceListGetActiveHomeDeliveryVersionQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof usePriceListGetActiveHomeDeliveryVersionHook>>
  >
>;
export type PriceListGetActiveHomeDeliveryVersionQueryError = unknown;

export const usePriceListGetActiveHomeDeliveryVersion = <
  TData = Awaited<
    ReturnType<ReturnType<typeof usePriceListGetActiveHomeDeliveryVersionHook>>
  >,
  TError = unknown,
>(
  params?: PriceListGetActiveHomeDeliveryVersionParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof usePriceListGetActiveHomeDeliveryVersionHook>
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = usePriceListGetActiveHomeDeliveryVersionQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const usePriceListSaveHomeDeliveryVersionHook = () => {
  const priceListSaveHomeDeliveryVersion = useCustomInstance<number>();

  return useCallback(
    (
      saveHomeDeliveryAndTradeInPriceListRequest: SaveHomeDeliveryAndTradeInPriceListRequest,
      params?: PriceListSaveHomeDeliveryVersionParams
    ) => {
      return priceListSaveHomeDeliveryVersion({
        url: `/api/PriceList/SaveHomeDeliveryVersion`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: saveHomeDeliveryAndTradeInPriceListRequest,
        params,
      });
    },
    [priceListSaveHomeDeliveryVersion]
  );
};

export const usePriceListSaveHomeDeliveryVersionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof usePriceListSaveHomeDeliveryVersionHook>>
    >,
    TError,
    {
      data: SaveHomeDeliveryAndTradeInPriceListRequest;
      params?: PriceListSaveHomeDeliveryVersionParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof usePriceListSaveHomeDeliveryVersionHook>>
  >,
  TError,
  {
    data: SaveHomeDeliveryAndTradeInPriceListRequest;
    params?: PriceListSaveHomeDeliveryVersionParams;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const priceListSaveHomeDeliveryVersion =
    usePriceListSaveHomeDeliveryVersionHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof usePriceListSaveHomeDeliveryVersionHook>>
    >,
    {
      data: SaveHomeDeliveryAndTradeInPriceListRequest;
      params?: PriceListSaveHomeDeliveryVersionParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return priceListSaveHomeDeliveryVersion(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type PriceListSaveHomeDeliveryVersionMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof usePriceListSaveHomeDeliveryVersionHook>>
  >
>;
export type PriceListSaveHomeDeliveryVersionMutationBody =
  SaveHomeDeliveryAndTradeInPriceListRequest;
export type PriceListSaveHomeDeliveryVersionMutationError = unknown;

export const usePriceListSaveHomeDeliveryVersion = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof usePriceListSaveHomeDeliveryVersionHook>>
    >,
    TError,
    {
      data: SaveHomeDeliveryAndTradeInPriceListRequest;
      params?: PriceListSaveHomeDeliveryVersionParams;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof usePriceListSaveHomeDeliveryVersionHook>>
  >,
  TError,
  {
    data: SaveHomeDeliveryAndTradeInPriceListRequest;
    params?: PriceListSaveHomeDeliveryVersionParams;
  },
  TContext
> => {
  const mutationOptions =
    usePriceListSaveHomeDeliveryVersionMutationOptions(options);

  return useMutation(mutationOptions);
};
export const usePriceListGetInternalDeliveryPriceVersionHook = () => {
  const priceListGetInternalDeliveryPriceVersion =
    useCustomInstance<InternalDeliveryPriceListModel>();

  return useCallback(
    (
      params?: PriceListGetInternalDeliveryPriceVersionParams,
      signal?: AbortSignal
    ) => {
      return priceListGetInternalDeliveryPriceVersion({
        url: `/api/PriceList/GetInternalDeliveryPriceVersion`,
        method: 'GET',
        params,
        signal,
      });
    },
    [priceListGetInternalDeliveryPriceVersion]
  );
};

export const getPriceListGetInternalDeliveryPriceVersionQueryKey = (
  params?: PriceListGetInternalDeliveryPriceVersionParams
) => {
  return [
    `/api/PriceList/GetInternalDeliveryPriceVersion`,
    ...(params ? [params] : []),
  ] as const;
};

export const usePriceListGetInternalDeliveryPriceVersionQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof usePriceListGetInternalDeliveryPriceVersionHook>
    >
  >,
  TError = unknown,
>(
  params?: PriceListGetInternalDeliveryPriceVersionParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof usePriceListGetInternalDeliveryPriceVersionHook>
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPriceListGetInternalDeliveryPriceVersionQueryKey(params);

  const priceListGetInternalDeliveryPriceVersion =
    usePriceListGetInternalDeliveryPriceVersionHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListGetInternalDeliveryPriceVersionHook>
      >
    >
  > = ({ signal }) => priceListGetInternalDeliveryPriceVersion(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListGetInternalDeliveryPriceVersionHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PriceListGetInternalDeliveryPriceVersionQueryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof usePriceListGetInternalDeliveryPriceVersionHook>
    >
  >
>;
export type PriceListGetInternalDeliveryPriceVersionQueryError = unknown;

export const usePriceListGetInternalDeliveryPriceVersion = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof usePriceListGetInternalDeliveryPriceVersionHook>
    >
  >,
  TError = unknown,
>(
  params?: PriceListGetInternalDeliveryPriceVersionParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof usePriceListGetInternalDeliveryPriceVersionHook>
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = usePriceListGetInternalDeliveryPriceVersionQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const usePriceListGetActiveInternalDeliveryVersionHook = () => {
  const priceListGetActiveInternalDeliveryVersion =
    useCustomInstance<InternalDeliveryPriceListModel>();

  return useCallback(
    (signal?: AbortSignal) => {
      return priceListGetActiveInternalDeliveryVersion({
        url: `/api/PriceList/GetActiveInternalDeliveryVersion`,
        method: 'GET',
        signal,
      });
    },
    [priceListGetActiveInternalDeliveryVersion]
  );
};

export const getPriceListGetActiveInternalDeliveryVersionQueryKey = () => {
  return [`/api/PriceList/GetActiveInternalDeliveryVersion`] as const;
};

export const usePriceListGetActiveInternalDeliveryVersionQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof usePriceListGetActiveInternalDeliveryVersionHook>
    >
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListGetActiveInternalDeliveryVersionHook>
      >
    >,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPriceListGetActiveInternalDeliveryVersionQueryKey();

  const priceListGetActiveInternalDeliveryVersion =
    usePriceListGetActiveInternalDeliveryVersionHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListGetActiveInternalDeliveryVersionHook>
      >
    >
  > = ({ signal }) => priceListGetActiveInternalDeliveryVersion(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListGetActiveInternalDeliveryVersionHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PriceListGetActiveInternalDeliveryVersionQueryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof usePriceListGetActiveInternalDeliveryVersionHook>
    >
  >
>;
export type PriceListGetActiveInternalDeliveryVersionQueryError = unknown;

export const usePriceListGetActiveInternalDeliveryVersion = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof usePriceListGetActiveInternalDeliveryVersionHook>
    >
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListGetActiveInternalDeliveryVersionHook>
      >
    >,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    usePriceListGetActiveInternalDeliveryVersionQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const usePriceListSaveInternalDeliveryPriceVersionHook = () => {
  const priceListSaveInternalDeliveryPriceVersion = useCustomInstance<number>();

  return useCallback(
    (
      saveInternalDeliveryPriceListRequest: SaveInternalDeliveryPriceListRequest
    ) => {
      return priceListSaveInternalDeliveryPriceVersion({
        url: `/api/PriceList/SaveInternalDeliveryPriceVersion`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: saveInternalDeliveryPriceListRequest,
      });
    },
    [priceListSaveInternalDeliveryPriceVersion]
  );
};

export const usePriceListSaveInternalDeliveryPriceVersionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListSaveInternalDeliveryPriceVersionHook>
      >
    >,
    TError,
    { data: SaveInternalDeliveryPriceListRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<
      ReturnType<typeof usePriceListSaveInternalDeliveryPriceVersionHook>
    >
  >,
  TError,
  { data: SaveInternalDeliveryPriceListRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const priceListSaveInternalDeliveryPriceVersion =
    usePriceListSaveInternalDeliveryPriceVersionHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListSaveInternalDeliveryPriceVersionHook>
      >
    >,
    { data: SaveInternalDeliveryPriceListRequest }
  > = (props) => {
    const { data } = props ?? {};

    return priceListSaveInternalDeliveryPriceVersion(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PriceListSaveInternalDeliveryPriceVersionMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListSaveInternalDeliveryPriceVersionHook>
      >
    >
  >;
export type PriceListSaveInternalDeliveryPriceVersionMutationBody =
  SaveInternalDeliveryPriceListRequest;
export type PriceListSaveInternalDeliveryPriceVersionMutationError = unknown;

export const usePriceListSaveInternalDeliveryPriceVersion = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListSaveInternalDeliveryPriceVersionHook>
      >
    >,
    TError,
    { data: SaveInternalDeliveryPriceListRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof usePriceListSaveInternalDeliveryPriceVersionHook>
    >
  >,
  TError,
  { data: SaveInternalDeliveryPriceListRequest },
  TContext
> => {
  const mutationOptions =
    usePriceListSaveInternalDeliveryPriceVersionMutationOptions(options);

  return useMutation(mutationOptions);
};
export const usePriceListGetFacilityExchangeVersionHook = () => {
  const priceListGetFacilityExchangeVersion =
    useCustomInstance<FacilityExchangePriceListModel>();

  return useCallback(
    (
      params?: PriceListGetFacilityExchangeVersionParams,
      signal?: AbortSignal
    ) => {
      return priceListGetFacilityExchangeVersion({
        url: `/api/PriceList/GetFacilityExchangeVersion`,
        method: 'GET',
        params,
        signal,
      });
    },
    [priceListGetFacilityExchangeVersion]
  );
};

export const getPriceListGetFacilityExchangeVersionQueryKey = (
  params?: PriceListGetFacilityExchangeVersionParams
) => {
  return [
    `/api/PriceList/GetFacilityExchangeVersion`,
    ...(params ? [params] : []),
  ] as const;
};

export const usePriceListGetFacilityExchangeVersionQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof usePriceListGetFacilityExchangeVersionHook>>
  >,
  TError = unknown,
>(
  params?: PriceListGetFacilityExchangeVersionParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof usePriceListGetFacilityExchangeVersionHook>
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPriceListGetFacilityExchangeVersionQueryKey(params);

  const priceListGetFacilityExchangeVersion =
    usePriceListGetFacilityExchangeVersionHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof usePriceListGetFacilityExchangeVersionHook>>
    >
  > = ({ signal }) => priceListGetFacilityExchangeVersion(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof usePriceListGetFacilityExchangeVersionHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PriceListGetFacilityExchangeVersionQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof usePriceListGetFacilityExchangeVersionHook>>
  >
>;
export type PriceListGetFacilityExchangeVersionQueryError = unknown;

export const usePriceListGetFacilityExchangeVersion = <
  TData = Awaited<
    ReturnType<ReturnType<typeof usePriceListGetFacilityExchangeVersionHook>>
  >,
  TError = unknown,
>(
  params?: PriceListGetFacilityExchangeVersionParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof usePriceListGetFacilityExchangeVersionHook>
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = usePriceListGetFacilityExchangeVersionQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const usePriceListGetActiveFacilityExchangeVersionHook = () => {
  const priceListGetActiveFacilityExchangeVersion =
    useCustomInstance<FacilityExchangePriceListModel>();

  return useCallback(
    (signal?: AbortSignal) => {
      return priceListGetActiveFacilityExchangeVersion({
        url: `/api/PriceList/GetActiveFacilityExchangeVersion`,
        method: 'GET',
        signal,
      });
    },
    [priceListGetActiveFacilityExchangeVersion]
  );
};

export const getPriceListGetActiveFacilityExchangeVersionQueryKey = () => {
  return [`/api/PriceList/GetActiveFacilityExchangeVersion`] as const;
};

export const usePriceListGetActiveFacilityExchangeVersionQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof usePriceListGetActiveFacilityExchangeVersionHook>
    >
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListGetActiveFacilityExchangeVersionHook>
      >
    >,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPriceListGetActiveFacilityExchangeVersionQueryKey();

  const priceListGetActiveFacilityExchangeVersion =
    usePriceListGetActiveFacilityExchangeVersionHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListGetActiveFacilityExchangeVersionHook>
      >
    >
  > = ({ signal }) => priceListGetActiveFacilityExchangeVersion(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListGetActiveFacilityExchangeVersionHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PriceListGetActiveFacilityExchangeVersionQueryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof usePriceListGetActiveFacilityExchangeVersionHook>
    >
  >
>;
export type PriceListGetActiveFacilityExchangeVersionQueryError = unknown;

export const usePriceListGetActiveFacilityExchangeVersion = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof usePriceListGetActiveFacilityExchangeVersionHook>
    >
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListGetActiveFacilityExchangeVersionHook>
      >
    >,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    usePriceListGetActiveFacilityExchangeVersionQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const usePriceListSaveFacilityExchangeVersionHook = () => {
  const priceListSaveFacilityExchangeVersion = useCustomInstance<number>();

  return useCallback(
    (
      saveFacilityExchangePriceListRequest: SaveFacilityExchangePriceListRequest
    ) => {
      return priceListSaveFacilityExchangeVersion({
        url: `/api/PriceList/SaveFacilityExchangeVersion`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: saveFacilityExchangePriceListRequest,
      });
    },
    [priceListSaveFacilityExchangeVersion]
  );
};

export const usePriceListSaveFacilityExchangeVersionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof usePriceListSaveFacilityExchangeVersionHook>>
    >,
    TError,
    { data: SaveFacilityExchangePriceListRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof usePriceListSaveFacilityExchangeVersionHook>>
  >,
  TError,
  { data: SaveFacilityExchangePriceListRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const priceListSaveFacilityExchangeVersion =
    usePriceListSaveFacilityExchangeVersionHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof usePriceListSaveFacilityExchangeVersionHook>>
    >,
    { data: SaveFacilityExchangePriceListRequest }
  > = (props) => {
    const { data } = props ?? {};

    return priceListSaveFacilityExchangeVersion(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PriceListSaveFacilityExchangeVersionMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof usePriceListSaveFacilityExchangeVersionHook>>
  >
>;
export type PriceListSaveFacilityExchangeVersionMutationBody =
  SaveFacilityExchangePriceListRequest;
export type PriceListSaveFacilityExchangeVersionMutationError = unknown;

export const usePriceListSaveFacilityExchangeVersion = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof usePriceListSaveFacilityExchangeVersionHook>>
    >,
    TError,
    { data: SaveFacilityExchangePriceListRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof usePriceListSaveFacilityExchangeVersionHook>>
  >,
  TError,
  { data: SaveFacilityExchangePriceListRequest },
  TContext
> => {
  const mutationOptions =
    usePriceListSaveFacilityExchangeVersionMutationOptions(options);

  return useMutation(mutationOptions);
};
export const usePriceListGetFacilityToFacilityVersionHook = () => {
  const priceListGetFacilityToFacilityVersion =
    useCustomInstance<FacilityToFacilityPriceListModel>();

  return useCallback(
    (
      params?: PriceListGetFacilityToFacilityVersionParams,
      signal?: AbortSignal
    ) => {
      return priceListGetFacilityToFacilityVersion({
        url: `/api/PriceList/GetFacilityToFacilityVersion`,
        method: 'GET',
        params,
        signal,
      });
    },
    [priceListGetFacilityToFacilityVersion]
  );
};

export const getPriceListGetFacilityToFacilityVersionQueryKey = (
  params?: PriceListGetFacilityToFacilityVersionParams
) => {
  return [
    `/api/PriceList/GetFacilityToFacilityVersion`,
    ...(params ? [params] : []),
  ] as const;
};

export const usePriceListGetFacilityToFacilityVersionQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof usePriceListGetFacilityToFacilityVersionHook>>
  >,
  TError = unknown,
>(
  params?: PriceListGetFacilityToFacilityVersionParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof usePriceListGetFacilityToFacilityVersionHook>
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPriceListGetFacilityToFacilityVersionQueryKey(params);

  const priceListGetFacilityToFacilityVersion =
    usePriceListGetFacilityToFacilityVersionHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListGetFacilityToFacilityVersionHook>
      >
    >
  > = ({ signal }) => priceListGetFacilityToFacilityVersion(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListGetFacilityToFacilityVersionHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PriceListGetFacilityToFacilityVersionQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof usePriceListGetFacilityToFacilityVersionHook>>
  >
>;
export type PriceListGetFacilityToFacilityVersionQueryError = unknown;

export const usePriceListGetFacilityToFacilityVersion = <
  TData = Awaited<
    ReturnType<ReturnType<typeof usePriceListGetFacilityToFacilityVersionHook>>
  >,
  TError = unknown,
>(
  params?: PriceListGetFacilityToFacilityVersionParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof usePriceListGetFacilityToFacilityVersionHook>
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = usePriceListGetFacilityToFacilityVersionQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const usePriceListGetActiveFacilityToFacilityVersionHook = () => {
  const priceListGetActiveFacilityToFacilityVersion =
    useCustomInstance<FacilityToFacilityPriceListModel>();

  return useCallback(
    (signal?: AbortSignal) => {
      return priceListGetActiveFacilityToFacilityVersion({
        url: `/api/PriceList/GetActiveFacilityToFacilityVersion`,
        method: 'GET',
        signal,
      });
    },
    [priceListGetActiveFacilityToFacilityVersion]
  );
};

export const getPriceListGetActiveFacilityToFacilityVersionQueryKey = () => {
  return [`/api/PriceList/GetActiveFacilityToFacilityVersion`] as const;
};

export const usePriceListGetActiveFacilityToFacilityVersionQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof usePriceListGetActiveFacilityToFacilityVersionHook>
    >
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListGetActiveFacilityToFacilityVersionHook>
      >
    >,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPriceListGetActiveFacilityToFacilityVersionQueryKey();

  const priceListGetActiveFacilityToFacilityVersion =
    usePriceListGetActiveFacilityToFacilityVersionHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListGetActiveFacilityToFacilityVersionHook>
      >
    >
  > = ({ signal }) => priceListGetActiveFacilityToFacilityVersion(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListGetActiveFacilityToFacilityVersionHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PriceListGetActiveFacilityToFacilityVersionQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListGetActiveFacilityToFacilityVersionHook>
      >
    >
  >;
export type PriceListGetActiveFacilityToFacilityVersionQueryError = unknown;

export const usePriceListGetActiveFacilityToFacilityVersion = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof usePriceListGetActiveFacilityToFacilityVersionHook>
    >
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListGetActiveFacilityToFacilityVersionHook>
      >
    >,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    usePriceListGetActiveFacilityToFacilityVersionQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const usePriceListSaveFacilityToFacilityVersionHook = () => {
  const priceListSaveFacilityToFacilityVersion = useCustomInstance<number>();

  return useCallback(
    (
      saveFacilityToFacilityPriceListRequest: SaveFacilityToFacilityPriceListRequest
    ) => {
      return priceListSaveFacilityToFacilityVersion({
        url: `/api/PriceList/SaveFacilityToFacilityVersion`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: saveFacilityToFacilityPriceListRequest,
      });
    },
    [priceListSaveFacilityToFacilityVersion]
  );
};

export const usePriceListSaveFacilityToFacilityVersionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListSaveFacilityToFacilityVersionHook>
      >
    >,
    TError,
    { data: SaveFacilityToFacilityPriceListRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof usePriceListSaveFacilityToFacilityVersionHook>>
  >,
  TError,
  { data: SaveFacilityToFacilityPriceListRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const priceListSaveFacilityToFacilityVersion =
    usePriceListSaveFacilityToFacilityVersionHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListSaveFacilityToFacilityVersionHook>
      >
    >,
    { data: SaveFacilityToFacilityPriceListRequest }
  > = (props) => {
    const { data } = props ?? {};

    return priceListSaveFacilityToFacilityVersion(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PriceListSaveFacilityToFacilityVersionMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof usePriceListSaveFacilityToFacilityVersionHook>>
  >
>;
export type PriceListSaveFacilityToFacilityVersionMutationBody =
  SaveFacilityToFacilityPriceListRequest;
export type PriceListSaveFacilityToFacilityVersionMutationError = unknown;

export const usePriceListSaveFacilityToFacilityVersion = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof usePriceListSaveFacilityToFacilityVersionHook>
      >
    >,
    TError,
    { data: SaveFacilityToFacilityPriceListRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof usePriceListSaveFacilityToFacilityVersionHook>>
  >,
  TError,
  { data: SaveFacilityToFacilityPriceListRequest },
  TContext
> => {
  const mutationOptions =
    usePriceListSaveFacilityToFacilityVersionMutationOptions(options);

  return useMutation(mutationOptions);
};
